module.exports = __webpack_public_path__ + "img/user3.c27f9412.png";